import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BoardService {
  pageSize: number = 20;
  boardList: BoardList[];

  constructor(
    private apiService:ApiService,
  ) {
  }

  getBoardList(): Observable<any> {
    return this.apiService.get('admin/board/list');
  }

  getPostListById(bbsId, page):Observable<any> {
    return this.apiService.get('admin/board/'+ bbsId + '/boardContent/list/' + this.pageSize + '/' + page);
  }

  getPostDetail(bbsId, cntntId):Observable<any> {
    return this.apiService.get('admin/board/' + bbsId + '/boardContent/' + cntntId);
  }

  postBoardContents(bbsId, content):Observable<any> {
    return this.apiService.post('admin/board/'+ bbsId + '/boardContent', content);
  }

  delBoardContents(bbsId, cntntId):Observable<any> {
    let delCon = {
      cntntId: cntntId
    }
    return this.apiService.delReqBodyType('admin/board/'+ bbsId + '/boardContents/' + cntntId, delCon);
  }

  patchBoardContents(bbsId, cntntId, content):Observable<any> {
    return this.apiService.patchReqBodyType('admin/board/'+ bbsId + '/boardContents/' + cntntId, content);
  }

  patchBoardStatus(bbsId, cntntId, status) {
    let body = {
      cntntId: cntntId,
      statusCd: status//NORMAL(R?), TEMPORARILY
    };

    return this.apiService.patchReqBodyType('admin/board/' + bbsId + '/boardContents/' + cntntId + '/status', body)
  }

  getBoardContentDetail(bbsId, cntntId):Observable<any> {
    return this.apiService.get('admin/board/'+ bbsId + '/boardContents/' + cntntId);
  }

  getBoardListOnInit(callback?: (value: BoardList[]) => void) {
    this.getBoardList().subscribe(
      resp=> {
        this.boardList = resp.data;
        callback(this.boardList);
      }
    )
  }

  postImage(file) {
    return this.apiService.post('admin/images', file);
  }

  getFileFolderList() {
    return this.apiService.get('admin/images/folders');
  }

  getImageList(folder) {
    return this.apiService.get('admin/images/folders/'+ folder);
  }

}

export class BoardList {
  baseUrl:string;
  bbsId: number;
  bbsNm: string;
}

export class BoardContentsForPost {
  bbsId: number;
  boardContentDetailParam: BoardContentDetail;
  cntntNo: number;
  cntntUrl: string;
  subject: string;
}

export class BoardContentsForPatch extends BoardContentsForPost {
  cntntId: number;
}

export class BoardContentDetail {
  content: string;
  headerContent: string;
}

export class BoardPostList { 
  pageNo: number;
  noOfElems: number;
  size: number;
  totalElems: number;
  totalPages: number;
  dataLst: BoardData[];
}

export class BoardData {
  bbsId: number;
  cntntId: number;
  cntntNo: number;
  cntntUrl: string;
  delYn: string;
  insDtm: string;
  insUser: InsertUser;
  readCnt: number;
  statusCd: string;
  subject: string;
  updDtm: string;
  updUser: InsertUser;
}

export class InsertUser {
  name:string;
  email:string;
}

export class BoardDetail extends BoardData{
  contentDetail: BoardContentDetail;
}


// WEBPACK FOOTER //
// ./src/app/services/board.service.ts